/* unplugin-vue-components disabled */import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=97a3e142&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户南京邮电-前端页面-saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97a3e142"]])

export default __exports__